import React, { useState } from "react";
import { Eye, Edit2, Trash2 } from "lucide-react";

function AddonCard({ group, onEdit, onDelete }) {
  const [showItems, setShowItems] = useState(false);

  return (
    <li className="addon-mobile-card">
      <div className="addon-card-header">
        <div>
          <h4 className="addon-card-title">{group.groupName}</h4> 
          <span className="addon-badge">
            Max Select: {group.maxSelection}
          </span>
        </div>

        <div className="addon-card-actions">
          <button
            type="button"
            class="serve-btn"
            onClick={() => onEdit(group)}
            aria-label="Edit"
          >
            {/* <Edit2 size={16} color="#0284c7" /> */}
            ✎ Edit
          </button>

          {/* <button class="serve-btn">✎ Edit</button> */}
          <button
            type="button"
            className="delete-cat"
            onClick={() => onDelete(group.addonGroupId)}
            aria-label="Delete"
          >
            {/* <Trash2 size={16} color="#dc2626" /> */}
            ✖ Delete
          </button>
        </div>
      </div>

      <div className="addon-card-body">
        <button
          type="button"
          className="addon-view-items-btn"
          onClick={() => setShowItems(!showItems)}
        >
          <Eye size={15} color="var(--ui-warning-text)" />
          <span>{showItems ? "Hide items" : `View items (${group.addonItems?.length || 0})`}</span>
        </button>

        {showItems && (
          <div className="addon-items-chips">
            {group.addonItems && group.addonItems.length > 0 ? (
              group.addonItems.map((item) => (
                <span key={item.addonItemId} className="addon-chip">
                  {item.itemName} <strong>₹{item.price}</strong>
                </span>
              ))
            ) : (
              <span className="no-items-text">No items inside this group</span>
            )}
          </div>
        )}
      </div>
    </li>
  );
}

export default AddonCard;